module.exports = __webpack_public_path__ + "img/title.2daa2c71.png";